import React from 'react';
import styled from 'styled-components';
import PlanViewer from '@component/gridgio/workspace/plan-viewer';
import Gap from '@component/common/gap';
import TextBlock from '@component/common/block/text-block';
import * as color from '@constant/color';
import type { IArea, IPlanPreviewModalData } from '@datatype/gridgio/type';
import * as size from '@constant/size';

interface IProps {
  data: IPlanPreviewModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FULL_AREA: IArea = {
  point: [
    { x: 0, y: 0 },
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 1 },
  ],
};

const PlanPreviewModal: React.FC<IProps> = ({ data }) => (
  <Wrapper>
    <TextBlock text='도면 미리보기' design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
    <Gap height={size.MARGIN_2} />
    <PlanViewer drawing={data} rotation={0} area={FULL_AREA} width='75vw' height='70vh' shadow={false} pagination controls />
  </Wrapper>
);

export default PlanPreviewModal;
